import React from 'react'
import { Link } from 'react-router-dom'

const stripTags = (html) => html.replace(/<[^>]+>/g, ' ')

// Groups the free-form `type` values in news.json into a few categories,
// each with its own icon and accent color.
export const CATEGORIES = {
  Papers: { icon: 'fa-file-lines', tone: 'blue' },
  Talks: { icon: 'fa-person-chalkboard', tone: 'teal' },
  Awards: { icon: 'fa-trophy', tone: 'amber' },
  People: { icon: 'fa-user-graduate', tone: 'rose' },
  Service: { icon: 'fa-handshake', tone: 'slate' },
}

export const categoryOf = (type = '') => {
  const t = type.toLowerCase()
  if (t.includes('presented') || t.includes('talk') || t === 'conference')
    return 'Talks'
  if (t.includes('acceptance') || t.includes('publication')) return 'Papers'
  if (t.includes('achievement') || t.includes('grant') || t.includes('award'))
    return 'Awards'
  if (t.includes('student') || t.includes('member') || t.includes('project'))
    return 'People'
  return 'Service'
}

const shortDate = (date = '') => {
  const month = date.match(/[A-Za-z]+/)
  const day = date.match(/\b\d{1,2}\b/)
  if (!month) return ''
  return `${month[0].slice(0, 3)}${day ? ` ${day[0]}` : ''}`
}

const NewsCard = ({ id, title, date, news, type, img }) => {
  let image = null
  if (img) {
    try {
      image = require(`../resources/${img}`)
    } catch (e) {
      image = null
    }
  }

  const category = categoryOf(type)
  const { icon, tone } = CATEGORIES[category]

  return (
    <Link to={`/news/${id}`} className='news-item'>
      <span className={`news-item__icon news-item__icon--${tone}`}>
        <i className={`fa-solid ${icon}`} />
      </span>
      <div className='news-item__body'>
        <div className='news-item__meta'>
          {type && <span>{type}</span>}
          {shortDate(date) && <span>{shortDate(date)}</span>}
        </div>
        <h3>{title}</h3>
        <p className='news-item__excerpt'>{stripTags(news.toString())}</p>
      </div>
      {image && (
        <div className='news-item__thumb'>
          <img src={image} alt='' loading='lazy' />
        </div>
      )}
      <i className='fa-solid fa-arrow-right news-item__arrow' />
    </Link>
  )
}

export default NewsCard
